import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import { onHideSuccessModal } from "../../store/slice/modalSlice";

import { useCmsHook } from "../../helpers/cmsHook";

function SuccessModal() {
  const { cmsInstance } = useCmsHook();
  const dispatch = useDispatch();
  const { successMessage } = useSelector((state) => state.modal);

  useEffect(() => {
    // Added timer for hiding success modal
    if (successMessage) {
      const timer = setTimeout(() => {
        dispatch(onHideSuccessModal());
      }, 3000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successMessage]);

  const checkMessagesFrom = () => {
    const message = successMessage.split(".");
    const messageFrom = message.includes("cmsContent");
    return messageFrom;
  };

  return (
    <div>
      <Modal
        className="my-modal"
        onHide={() => dispatch(onHideSuccessModal())}
        show={successMessage}
      >
        <div className="success-modal">
          <div className="d-flex flex-row justify-content-end">
            <Button
              className="success-modal-button"
              onClick={() => dispatch(onHideSuccessModal())}
            >
              ×
            </Button>
          </div>
          {checkMessagesFrom() ? (
            <>
              {cmsInstance &&
                cmsInstance.showRichText(
                  successMessage,
                  "success-modal-message"
                )}
            </>
          ) : (
            <p className="success-modal-message mb-4 mx-3">{successMessage}</p>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default SuccessModal;
